import { render } from "./SpeeddialComponent.vue?vue&type=template&id=174b3c24"
import script from "./SpeeddialComponent.vue?vue&type=script&lang=js"
export * from "./SpeeddialComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__